import { BaseControl } from './base';

export class SelectControl extends BaseControl {}
